<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12">
        <div class="d-flex justify-space-between">
          <div>
            <div class="text-h4 font-weight-bold">Intern Coretime Approval</div>
            <div class="text-subtitle-2">
              <span class="text-grey">Approve work schedule for interns</span>
            </div>
          </div>
          <!-- <div class="rounded-lg border border-1 pa-4 d-flex align-center">
            <div class="pa-2">
              <div class="text-caption text-grey font-weight-bold">
                TOTAL HOURS
              </div>
              <div class="text-subtitle-1" style="color: #00a63e">
                <span class="font-weight-bold">27.75</span> /
                <span class="text-caption text-grey">486 hrs</span>
              </div>
            </div>
            <div style="border-left: 1px solid grey" class="pa-4">
              <div class="text-caption text-grey">Progress</div>
              <div class="text-subtitle-1" style="color: #00a63e">
                <v-progress-linear
                  color="#00a63e"
                  height="10"
                  model-value="10"
                  striped
                ></v-progress-linear>
              </div>
            </div>
          </div> -->
        </div>
      </v-col>
      <v-col cols="12" md="6" class="flex-items mt-2">
        <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :key="tab.id"
            :value="tab.name"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
    </v-row>

    <v-col cols="12">
      <div class="mt-4">
        <v-row v-if="!expandTab1">
          <v-col cols="12">
            <v-card elevation="2" class="pa-2">
              <v-data-table
                :headers="headers"
                :items="table_data"
                :search="search"
                :loading="loading"
                hover
                density="compact"
                class="rounded-lg"
              >
                <template v-slot:[`item.date_from`]="{ item }">
                  <span>{{ formatDate(item.date_from) }}</span>
                </template>
                <template v-slot:[`item.date_to`]="{ item }">
                  <span>{{ formatDate(item.date_to) }}</span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    class="white--text"
                    color="#00A63E"
                    size="x-small"
                    rounded
                    @click="viewItem(item)"
                  >
                    View
                  </v-btn>
                </template>

                <template #no-data> You have no coretime to approve. </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tab == 1 && expandTab1"> </v-row>
      </div>
    </v-col>

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ViewInternCoretimeDialog
      :data="itemData"
      :action="action"
      :approvalByFieldOfficer="getIsFieldOfficerUser"
    />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import ViewInternCoretimeDialog from "../Dialogs/Views/ViewInternCoretimeDialog.vue";

export default {
  components: {
    ViewInternCoretimeDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    itemData: null,
    search: "",
    headers: [
      { title: "Date From", value: "date_from", align: "start" },
      { title: "Date To", value: "date_to", align: "start" },
      { title: "Action", value: "action", align: "center" },
    ],
    data: [],
    activeTab: { id: 1, name: "For Approval" },
    tab: 1,
    tabList: [
      { id: 1, name: "For Approval" },
      { id: 2, name: "Approved" },
      { id: 3, name: "Pending" },
    ],
    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    table_data: [],
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),

  computed: {
    getIsFieldOfficerUser() {
      return this.$store.state.user.user.usertypeID == 9;
    },
  },
  mounted() {
    this.initialize();

    eventBus.on("closeStudentCoretimeDialog", () => {
      this.initialize();
    });
  },

  beforeUnmount() {
    eventBus.off("closeStudentCoretimeDialog");
  },
  methods: {
    formatType(type) {
      const labels = {
        am_in: "Morning Time In",
        am_out: "Morning Time Out",
        pm_in: "Afternoon Time In",
        pm_out: "Afternoon Time Out",
      };
      return labels[type] || type;
    },
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      if (this.getIsFieldOfficerUser) {
        this.axiosCall(
          "/student-coretime/getMyAssignedInternsCoretime/" + this.tab,
          "GET",
        ).then((res) => {
          if (res) {
            this.table_data = res.data;
          }
        });
      } else {
        this.axiosCall(
          "/student-coretime/getMyInternsCoretime/" + this.tab,
          "GET",
        ).then((res) => {
          if (res) {
            this.table_data = res.data;
          }
        });
      }
    },

    changeTab(tab) {
      this.activeTab = tab.name;
      this.tab = tab.id;

      this.initialize();
    },

    viewItem(item) {
      this.itemData = item;
      this.action = this.tab == 1 ? "Approve" : "View";
    },

    manageItem(item) {
      this.creds = item;
    },
  },
};
</script>
